import { Controller } from "@hotwired/stimulus";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import InfiniteScroll from "infinite-scroll";

InfiniteScroll.imagesLoaded = imagesLoaded;

export default class extends Controller {
  connect() {
    const dataGutter = this.element.dataset.gutter;
    const gutter = dataGutter ? Number(dataGutter) : 20;
    const infiniteItemSelector = this.element.dataset.infiniteItemSelector;
    const infiniteNextSelector = this.element.dataset.infiniteNextSelector;

    // Store initial screen size to detect meaningful changes
    this.initialIsLargeScreen = window.matchMedia('(min-width: 760px)').matches;

    // Setup debounced resize handler
    this.setupResizeHandler();

    const isLargeScreen = this.initialIsLargeScreen;
    const columnCount = isLargeScreen ? 3 : 1;

    if (columnCount <= 1) {
      this.element.classList.remove("opacity-0", "min-h-screen");
      this.element.classList.add("space-y-6");
      return;
    }

    const baseWidth = Math.floor(
      this.element.getBoundingClientRect().width / columnCount,
    );

    if (this.element.querySelectorAll(".masonryItem").length <= 0) {
      this.element.querySelectorAll(".card").forEach((div, index) => {
        if (index === 0) {
          div.classList.add("masonryItem");
          div.classList.add("masonryItemW2");
        } else {
          div.classList.add("masonryItem");
        }
      });
    }

    imagesLoaded(this.element, (instance) => {
      const msnry = new Masonry(this.element, {
        itemSelector: ".masonryItem",
        columnWidth: ".masonryGridSizer",
        percentPosition: true,
        gutter,
        transitionDuration: 0,
      });

      if (infiniteItemSelector && infiniteNextSelector) {
        const infScroll = new InfiniteScroll(this.element, {
          path: infiniteNextSelector,
          append: infiniteItemSelector,
          history: false,
          outlayer: msnry,
        });
        console.log(infScroll);
      }
    });

    this.element.classList.remove("opacity-0", "min-h-screen", "space-y-6");
  }

  disconnect() {
    // Clean up resize listener when controller disconnects
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    window.removeEventListener('resize', this.debouncedResize);
  }

  setupResizeHandler() {
    this.debouncedResize = this.debounce(() => {
      const currentIsLargeScreen = window.matchMedia('(min-width: 760px)').matches;

      // Only reload if screen size category changed (mobile <-> desktop)
      if (currentIsLargeScreen !== this.initialIsLargeScreen) {
        window.location.reload();
      }
    }, 300); // 300ms debounce delay

    window.addEventListener('resize', this.debouncedResize);
  }

  debounce(func, wait) {
    return (...args) => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}
